<script setup lang="ts">
type Props = {
  polygon?: string
  trumpet?: string
  title?: string
}

const _props = defineProps<{ data: Props; theme: string | null }>()

const { data: speciesData } = await useSpeciesData(_props.data.polygon)
</script>

<template>
  <div>
    <div class="px-bleed relative w-full overflow-clip">
      <div class="grid gap-5 md:gap-18" :class="{ 'border-t border-(--theme-fg)/15': data.title }">
        <h2 v-if="data.trumpet" class="mt-8 text-sm font-bold uppercase">{{ data.trumpet }}</h2>
        <h3 v-if="data.title" class="font-display text-xl lg:text-3xl">{{ data.title }}</h3>
      </div>
    </div>
    <CarouselsSpeciesLive :items="speciesData?.liveFeed.items" />
  </div>
</template>
